const landing = {
    getList: 'landing/getlist',
    add: 'landing/add',
    edit: 'landing/update',
    get: 'landing/get',
    remove: 'landing/remove'
}

export default landing